{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "בוחר הצבעים",
  "twoDimensionalSlider": "מחוון דו מימדי",
  "colorSwatch": "color swatch",
  "transparent": "transparent"
}
